import request from '../utils/request';

export function getArticleList(param) {
    return request({
        url: '/admin/search-article',
        method: 'GET',
        params: param
    })
}

export function saveArticle(id, data) {
    if (id === 0) {
        return request({
            url: '/admin/article',
            method: 'POST',
            data
        })
    }
    return request({
        url: '/admin/article/'+id,
        method: 'PUT',
        data
    })
}

export function deleteArticle(id) {
    return request({
        url: '/admin/article/'+id,
        method: 'DELETE'
    })
}

